$.fn.serializeObject = function()
{
   var o = {};
   var a = this.serializeArray();
   $.each(a, function() {
       if (this.name.indexOf(".") != -1){
          splitted = this.name.split(".");
          if(!o[splitted[0]])
              o[splitted[0]] = {};
          o[splitted[0]][splitted[1]] = this.value || '';
          return;
       }
       if (o[this.name]) {
           if (!o[this.name].push) {
              o[this.name] = [o[this.name]];
           }
           o[this.name].push(this.value || '');
       } else {
           o[this.name] = this.value || '';
       }
   });
   return o;
};